// Reads the file name the server chose from a Content-Disposition header. A name with
// non-ASCII characters arrives URL-encoded as filename*=utf-8''<name>.
export function filenameFromContentDisposition(
  contentDisposition: string | undefined | null
): string | null {
  const encodedMatch = contentDisposition?.match(/filename\*=(?:utf-8|UTF-8)''([^;]+)/);
  if (encodedMatch) {
    try {
      return decodeURIComponent(encodedMatch[1]);
    } catch {
      // a malformed encoded name falls back to the plain one below
    }
  }
  const match = contentDisposition?.match(/filename="?([^";]+)"?/i);
  return match ? match[1] : null;
}

export function downloadBlob(blob: Blob, filename: string): void {
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.click();
  // revoked later rather than immediately so the browser has started the download
  setTimeout(() => URL.revokeObjectURL(objectUrl), 10_000);
}
